export default __webpack_public_path__ + "static/media/mlp-card-2.5a4f69c5.png";